/**
 * PortalAccountSelector
 *
 * Handles the creating and managing the account selection widget
 */

// the constructor for this object
function PortalAccountSelector() { }

// the object
PortalAccountSelector.prototype = {
    constructor: PortalAccountSelector,
    
    // the selector for the accounts dropdown
    dropdownSelector: false,
    
    // if the dropdown should store the selected account id globablly
    dropdownStoreAccountId: true,
    
    // if the dropdown should have the all accounts option
    dropdownAllAccountsOption: true,
    
    // the account id to be used if all accounts is the active id, but the dropdown doesn't support it
    dropdownDefaultAccountId: false,
    
    // populate the accounts dropdown, and register the callback event for it
    setupAccountsDropdown: function(selector, onChangeCallback)
    {
        this.dropdownSelector = selector;
        
        this._buildDropdownList();
        this._buildDropdownLabel(PortalMain.PortalAccounts.getCurrentAccountId());
        this._buildDropdownEvent(onChangeCallback);
    },
    
    // get the account id currently set in the accounts dropdown
    getDropdownAccountId: function()
    {
        var accountId = $('.selection-text', this.dropdownSelector).attr('data-account-id');
        return accountId;
    },
    
    // populate the dropdown with the accounts
    _buildDropdownList: function()
    {
        var accounts = PortalMain.PortalAccounts.getAccounts();
        
        // add the all accounts options
        if (this.dropdownAllAccountsOption) {
            accounts.unshift({
                account_number: 'All Accounts',
                account_id: 0
            });
        }
        
        // build the accounts list
        for (var i in accounts) {
            var account = accounts[i];
            
            // the text to display
            var text = account.account_number;
            if (parseInt(text)) {
                text = '#' + text;
            }
            if (account.name) {
                text += '<br><span class="light">' + account.name + '</span>';
            }
            if (account.account_status_cd == 'D') {
                text += '<br><span class="error">Disconnected</span>';
            }
            
            // clone the html and apply the link, and text
            var newLink = $('ul .clone-source', this.dropdownSelector).clone();
            newLink.removeClass('hidden clone-source');
            $('a', newLink).attr('data-account-id', account.account_id);
            $('a', newLink).html(text);
            $('ul', this.dropdownSelector).append(newLink);
        }
    },
    
    // populate the dropdown label with the current account
    _buildDropdownLabel: function(accountId)
    {
        var accounts = PortalMain.PortalAccounts.getAccounts();
        
        // set the default account id to be used because all accounts isn't an option
        if (this.dropdownAllAccountsOption === false
        && accountId == 0) {
            accountId = this.dropdownDefaultAccountId;
        }
        
        // get the account number of the active account, and if it is disconnected
        var label = 'All Accounts';
        var disconnected = false;
        for (var i in accounts) {
            if (accounts[i].account_id == accountId) {
                label = 'Acct. ' + accounts[i].account_number;
                if (accounts[i].account_status_cd == 'D') {
                    disconnected = true;
                }
            }
        }
        
        $('.selection-text', this.dropdownSelector).removeClass('error');
        if (disconnected) {
            $('.selection-text', this.dropdownSelector).addClass('error');
        }
        
        $('.selection-text', this.dropdownSelector).attr('data-account-id', accountId);
        $('.selection-text', this.dropdownSelector).html(label);
    },
    
    // build the event for when the account is changed
    _buildDropdownEvent: function(onChangeCallback)
    {
        // turn off any prior events
        $('ul a', this.dropdownSelector).off('click');
        
        // the dropdown events
        var self = this;
        PortalHelper.hideDropdownOnClick(this.dropdownSelector);
        $('ul a', this.dropdownSelector).on('click', function() {
            
            var currentAccountId = PortalMain.PortalAccounts.getCurrentAccountId();
            var newAccountId = $(this).attr('data-account-id');
            
            // only run the event if a new account id, or if the dropdown doesn't store account id
            if (newAccountId != currentAccountId
            || !self.dropdownStoreAccountId) {
                
                if (self.dropdownStoreAccountId) {
                    PortalMain.PortalAccounts._storeCurrentAccountId(newAccountId);
                }
                
                self._buildDropdownLabel(newAccountId);
                
                if (typeof onChangeCallback == 'function') {
                    onChangeCallback(newAccountId);
                }
            }
            
        });
    },
}
